import { render, staticRenderFns } from "./KazangBanner.vue?vue&type=template&id=dd68d32c&scoped=true"
import script from "./KazangBanner.vue?vue&type=script&lang=js"
export * from "./KazangBanner.vue?vue&type=script&lang=js"
import style0 from "./KazangBanner.vue?vue&type=style&index=0&id=dd68d32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd68d32c",
  null
  
)

export default component.exports